import { Component, OnInit } from '@angular/core';
import { ContactUsService } from '@core/services/contact.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
})

export class BlogComponent implements OnInit {
  AllBlogs: any;
  p = 0;
  paginate: any;

  constructor(
    private contactService: ContactUsService,
  ) { }

  ngOnInit(): void {
    this.getAllBlogs();
  }

  getAllBlogs(start = 0) {
    this.contactService.getBlog(0, 120).subscribe(res => {
      if (res) {
        this.AllBlogs = res.Object.objects;
      }
    }, err => {
    });
  }
  
  search(event: any) {
    this.contactService.getBlog(0,120,event.target.value).subscribe(res => {
      if (res)
        this.AllBlogs = res.Object.objects;
    }, err => {
    });
  }

}
